import {ImpressaoService} from "../services/impressao.service";
import {PedidosService} from "../services/pedidos.service";
import {ProcessadorReciboTexto} from "../services/impressao/ProcessadorReciboTexto";
import { NfceService } from "../services/nfce.service";
import {DiarioImpressaoNfce} from '../services/impressao/DiarioImpressaoNfce';



export   class TelaImprimirPedido  {
  empresa: any = {}
  _pedido: any = {}
  pedidosImprimir = {}
  host: any;
  nfcesImprimir: any[] = [];
  constructor( protected impressao: ImpressaoService , protected  pedidoService: PedidosService, protected nfeService: NfceService) {
    this.host = location.origin;
  }

  private obtenhaEmpresaImpressao(pedido: any = this._pedido) {
    if(this.deveUsarEmpresaDoPedidoParaImpressao() && pedido?.empresa?.configImpressao)
      return pedido.empresa;

    return this.empresa;
  }

  private obtenhaConfigImpressao(pedido: any = this._pedido) {
    return this.obtenhaEmpresaImpressao(pedido)?.configImpressao;
  }

  private obtenhaImpressorasImprimir(){
    const empresaImpressao = this.obtenhaEmpresaImpressao();
    const configImpressao = this.obtenhaConfigImpressao();

    if(!configImpressao || !configImpressao.imprimirTXT) return [];

    let impressorasDasCategorias = [], produtosPorImpressora: any = {}

    if(configImpressao.multiplasImpressoras){
      this._pedido.itens.map( itemPedido => itemPedido.produto).forEach(produto => {
        if(produto.categoria){
          if(empresaImpressao.catalogo && empresaImpressao.catalogo.categorias) {
            let categoria = empresaImpressao.catalogo.categorias.find( cat => cat.id === produto.categoria.id);

            if(categoria && categoria.impressoras.length){
              let impressorasIds = categoria.impressoras.map(impressora => impressora.id);

              impressorasIds.forEach((impressoraId: number) => {
                if(!produtosPorImpressora[impressoraId]) produtosPorImpressora[impressoraId] = []

                produtosPorImpressora[impressoraId].push(produto)
              })

              impressorasDasCategorias = impressorasDasCategorias.concat(impressorasIds)
            }
          }
        }
      })
    }

    let impressorasAuto = (configImpressao.impressoras || []).filter(
      impressora => (impressorasDasCategorias.indexOf( impressora.id) >= 0 || impressora.imprimirAutomatico) &&
        (this._pedido.mesa ? !impressora.naoImprimePedidosMesa : !impressora.naoImprimePedidosDelivery)
    );

    let descricaoImpressoras = [];
    const ocultarProdutosImpressaoPorCategoria =
      configImpressao.ocultarProdutosImpressaoPorCategoria !== false;

    impressorasAuto = impressorasAuto.filter((item: any) => !item.servidorImpressao);

    impressorasAuto.forEach((impressora: any) => {
      if(!impressora.layout)
        impressora.layout = configImpressao.layoutPedido

      impressora.impressaoAutoCategoria = false;

      if(produtosPorImpressora[impressora.id]) {
        impressora.produtos = produtosPorImpressora[impressora.id]
        impressora.impressaoAutoCategoria = ocultarProdutosImpressaoPorCategoria && !impressora.imprimirAutomatico
      }

      descricaoImpressoras.push(impressora.nome + (impressora.setor ? " (" + impressora.setor + ")" : ""))
    })

    console.log("Imprimindo nas impressoras", descricaoImpressoras)
    return impressorasAuto
  }

  private obtenhaImpressorasAutoCancelamentoPedido(dadosCancelamento: any){
    const configImpressao = this.obtenhaConfigImpressao(dadosCancelamento);

    if(!configImpressao || !configImpressao.imprimirTXT) return [];

    const impressorasAuto = (configImpressao.impressoras || []).filter(
      (impressora: any) => impressora.imprimirAutomatico && !impressora.naoImprimePedidosDelivery
    );

    return impressorasAuto.filter((item: any) => !item.servidorImpressao);
  }

  async imprimaCancelamentoPedidoNaoPago(dadosCancelamento: any) {
    const impressoras = this.obtenhaImpressorasAutoCancelamentoPedido(dadosCancelamento);

    for(let i = 0; i < impressoras.length; i++) {
      if(!this.podeContinuarImpressaoAutomatica()) return;

      await this.impressao.imprimaCancelamentoPedidoNaImpressora(dadosCancelamento, impressoras[i]);
    }
  }

  async imprimaNfces(nfces: any){
    // Adiciona nfces na lista se não existir outra com mesmo ID
    for(let i = 0; i < nfces.length; i++){
      const nfceExistente = this.nfcesImprimir.some(nfceNaLista =>
        nfceNaLista.numeroNFe === nfces[i].numeroNFe || nfceNaLista.id === nfces[i].id
      );

      if(!nfceExistente){
        this.nfcesImprimir.push(nfces[i]);
      }
    }
    console.log('total nfces chegou para imprimir: ' + nfces.length)
    for(let i = 0; i < nfces.length; i++){
      if(!this.podeContinuarImpressaoAutomatica()) return;

      let nfce = nfces[i]
      console.log('imprimindo nfce:' + nfce.numeroNFe)
      await this.imprimaAutomaticamenteNfce(nfce)

      //remove nfce impressa se já existir um objeto com mesmo id na lista
      this.nfcesImprimir = this.nfcesImprimir.filter(nfceNaLista => nfceNaLista.id !== nfce.id);
    }
  }

  async imprimaFilaSmartPos() {
    const chave=`smartpos-impressao-pc:${this.empresa.id}`;
    // Web Locks coordena abas e instâncias do mesmo origin; sem exclusão, conserve a fila.
    const locks=(navigator as any).locks;
    if(!locks)throw new Error('Este navegador não oferece exclusão segura para impressão Smart POS.');
    await locks.request(chave,{mode:'exclusive',ifAvailable:true},async (lock:any)=>{
      if(lock)await this.imprimaFilaSmartPosExclusiva(chave);
    });
  }

  private async imprimaFilaSmartPosExclusiva(chave:string) {
    const diario:Record<string,any>=JSON.parse(localStorage.getItem(chave)||'{}');
    const salve=()=>localStorage.setItem(chave,JSON.stringify(diario));
    const uuid=()=>{const b=new Uint8Array(16);crypto.getRandomValues(b);b[6]=(b[6]&15)|64;b[8]=(b[8]&63)|128;const h=Array.from(b,x=>x.toString(16).padStart(2,'0')).join('');return `${h.slice(0,8)}-${h.slice(8,12)}-${h.slice(12,16)}-${h.slice(16,20)}-${h.slice(20)}`;};
    const canonico=(v:any):string=>v&&typeof v==='object'?(Array.isArray(v)?'['+v.map(canonico).join(',')+']':'{'+Object.keys(v).sort().map(k=>JSON.stringify(k)+':'+canonico(v[k])).join(',')+'}'):JSON.stringify(v);
    const entregue=async(id:string)=>{
      const local=diario[id];if(!local.resultado)return;
      const ack=await this.nfeService.resultadoImpressaoSmartPos(Number(id),local.resultado);
      const digest=await crypto.subtle.digest('SHA-256',new TextEncoder().encode(canonico(local.resultado)));
      const hash=Array.from(new Uint8Array(digest),x=>x.toString(16).padStart(2,'0')).join('');
      if(ack.eventoId!==local.resultado.eventoId||ack.eventoHash!==hash)throw new Error('ACK da impressão não corresponde ao evento salvo.');
      delete diario[id];salve();
    };
    // Um resultado cujo ACK se perdeu não aparece necessariamente na fila pendente.
    for(const id of Object.keys(diario))if(diario[id].resultado)await entregue(id);
    const {impressoes}=await this.nfeService.listeImpressoesSmartPos();
    for(const job of impressoes||[]) {
      if(!this.podeContinuarImpressaoAutomatica())return;
      const anterior=diario[job.id];
      if(job.situacao==='DESPACHO_AUTORIZADO') {
        if(anterior&&anterior.execucaoId===job.execucaoId){
          anterior.resultado={eventoId:uuid(),execucaoId:job.execucaoId,documentoHash:job.documento.hash,situacao:'INCERTA',mensagem:'Consumidor reiniciado após autorização do despacho.'};salve();await entregue(String(job.id));
        }
        continue;
      }
      if(job.situacao!=='SOLICITADA')continue;
      const impressora=(this.empresa.configImpressao?.impressoras||[]).find((p:any)=>(p.imprimirNFCe || job.tipoDocumento==='COMERCIAL'&&p.imprimirAutomatico)&&!p.removida&&!p.servidorImpressao);
      if(!impressora || !await this.impressao.possuiQZ())continue;
      const execucaoId=anterior?.execucaoId||uuid();diario[job.id]={execucaoId};salve();
      // Resposta perdida conserva o despacho local. A retomada apenas registra incerteza.
      const {impressao}=await this.nfeService.autorizeImpressaoSmartPos(job.id,execucaoId);
      if(impressao.situacao!=='DESPACHO_AUTORIZADO')continue;
      // Diário preexistente é recuperação de um despacho possivelmente executado, nunca novo papel.
      const ok=!anterior && await this.impressao.imprimaDocumentoSmartPos(job.documento,impressora).catch(()=>false);
      diario[job.id].resultado={eventoId:uuid(),execucaoId,documentoHash:job.documento.hash,situacao:ok?'ENVIADA':'INCERTA',mensagem:ok?null:'Falha após autorização; não é seguro repetir automaticamente.'};
      salve();await entregue(String(job.id));
    }
  }

  async marqueNfceComoImpressa(nfce: any) {
    try {
      console.log(`Marcando NFCe ${nfce.numeroNFe} como impressa`);
      await this.nfeService.marqueImpressa(nfce);
      return true;
    } catch (erro) {
      console.error(`Erro ao marcar NFCe ${nfce.numeroNFe} como impressa:`, erro);
      return false;
    }
  }

  async imprimaAutomaticamenteNfce(nfce: any) {
    try {
      console.log(`Imprimindo automaticamente NFCe ${nfce.numeroNFe}`);
      console.log(nfce)

      // Obter impressoras configuradas para NFCe
      const impressoras = this.empresa.configImpressao.impressoras.filter(
        impressora => impressora.imprimirNFCe
      );

      if (!impressoras.length) {
        console.log('Nenhuma impressora configurada para imprimir NFCe');
        return false;
      }

      const diario = new DiarioImpressaoNfce();
      let todasEnviadas = true;
      for (let i = 0; i < impressoras.length; i++) {
        if(!this.podeContinuarImpressaoAutomatica()) return false;

        const impressora = impressoras[i];
        const destino = impressora.id ? `id:${impressora.id}` : `nome:${impressora.nome}`;
        const chave = JSON.stringify([this.empresa.id, nfce.id, destino]);
        const anterior = await diario.obtenha(chave);
        if(anterior === 'ENVIADA') continue;
        if(anterior === 'INCERTA') {
          nfce.erroImpressao = `Envio anterior à impressora ${impressora.nome} sem confirmação. Confira a impressão antes de reimprimir manualmente.`;
          this.impressao.onErrosImpressao.emit(nfce.erroImpressao);
          todasEnviadas = false;
          continue;
        }
        console.log(`Imprimindo NFCe ${nfce.numeroNFe} na impressora ${impressora.nome}`);
        let despachoReservado = false;
        const enviada = await this.impressao.imprimaNfceNaImpressora(nfce, impressora, async () => {
          despachoReservado = await diario.reserveDespacho(chave);
          if(!despachoReservado) throw new Error('O despacho desta NFC-e já foi reservado em outra execução.');
        });
        if(enviada && despachoReservado) await diario.confirmeEnvio(chave);
        else todasEnviadas = false;
      }

      return todasEnviadas && await this.marqueNfceComoImpressa(nfce);
    } catch (erro) {
      console.error(`Erro ao imprimir automaticamente NFCe ${nfce.numeroNFe}:`, erro);
      return false;
    }
  }


 async imprimaNovosPedidos(pedidos: any){
   console.log('total pedidos chegou para imprimir: ' + pedidos.length)
   let pedidosImprimir = [];

   pedidos.forEach((pedido: any) => {
     if(!this.pedidosImprimir[pedido.id]){
       this.pedidosImprimir[pedido.id] = pedido;
       pedidosImprimir.push(pedido)
     }
   })

   console.log('total pedidos imprimir: ' + pedidosImprimir.length)
    for(let i = 0; i < pedidosImprimir.length; i++){
      if(!this.podeContinuarImpressaoAutomatica()) {
        pedidosImprimir.slice(i).forEach((pedido: any) => this.pedidosImprimir[pedido.id] = null);
        return;
      }

      this._pedido = pedidosImprimir[i];
      console.log('imprimindo pedido:' + this._pedido.codigo)
      await this.envieImpressaoAutomatica(true);
    }
  }

  async envieImpressaoAutomatica(impressoPeloMonitorador = false){

    try{
      let impressoras = this.obtenhaImpressorasImprimir();
      if(!impressoras.length) return;

      console.log('imprimir automaticamente nas impressoras: ' + impressoras.map(impressora => impressora.nome).join(', '))

      for(let i = 0; i <  impressoras.length; i++){
        if(!this.podeContinuarImpressaoAutomatica()) return;

        await   this.imprimaNativamente(impressoras[i], this._pedido, impressoPeloMonitorador)
      }
    } finally {

      this.pedidosImprimir[this._pedido.id] = null
    }

  }

  async imprimaNativamente(impressora: any, pedido: any, impressoPeloMonitorador = false){
    console.log(String(`imprimir pedido: ${pedido.codigo}`));

    if(!impressora.servidorImpressao){
      let processadorReciboTexto = new ProcessadorReciboTexto(impressora);

      let imprimiu: boolean = await  this.impressao.imprima(processadorReciboTexto.obtenhaRecibo(pedido, impressora.layout),
        processadorReciboTexto.impressora, String(`imprimir pedido ${pedido.codigo} na impressora ${impressora.nome}`))

      if(imprimiu){
        console.log(String(`marcar  pedido como impresso: ${pedido.codigo}`));
        await this.marqueFoiImpresso(pedido, impressoPeloMonitorador, impressora)
        this.impressao.onPedidoImpresso.emit({pedido, impressora});
      } else{
        console.log("Houve um erro ao imprimir, será feita uma nova tentativa")
      }
    } else {
      await this.impressao.envieImprimirRemotamente(pedido, impressora);
    }

    this.pedidosImprimir[pedido.id] = null
  }

  protected marqueFoiImpresso(pedido: any, impressoPeloMonitorador = false, impressora: any = null) {
    return this.pedidoService.marqueFoiImpresso(pedido, impressoPeloMonitorador, impressora);
  }

  protected podeContinuarImpressaoAutomatica() {
    return true;
  }

  protected deveUsarEmpresaDoPedidoParaImpressao() {
    return false;
  }

}
